var map = {
	"./bitbucket.png": "d95b",
	"./bootstrap.png": "ea77",
	"./centos.png": "df0c",
	"./css.png": "dc5a",
	"./datatablejs.png": "293d",
	"./digitalocean.png": "d441",
	"./git.png": "5989",
	"./gitlab.png": "6cdf",
	"./highcharts.png": "78a1",
	"./html5.png": "da32",
	"./javascript.png": "85e7",
	"./material-design.png": "d291",
	"./mongodb.png": "0d78",
	"./mysql.png": "04e2",
	"./php.png": "2fdd",
	"./postgresql.png": "111e",
	"./reactjs.png": "0463",
	"./ror.png": "fc1b",
	"./ruby.png": "9c89",
	"./sass.png": "02c1",
	"./ubuntu.png": "a3af",
	"./vuejs.png": "77c0",
	"./webpack.png": "089e",
	"./wordpress.png": "8f94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b879";